// 2. Composant pour les médicaments/analyses avec édition
// components/consultation/summary/EditableList.tsx
import React from 'react';

interface EditableListProps<T> {
  items: T[];
  renderItem: (item: T, index: number) => React.ReactNode;
  onEdit: (index: number) => void;
  onReturnToForm: () => void;
  emptyMessage: string;
  bgColor: string;
  borderColor: string;
  buttonColor: string;
  buttonHoverColor: string;
}

export function EditableList<T>({
  items,
  renderItem,
  onEdit,
  onReturnToForm,
  emptyMessage,
  bgColor,
  borderColor,
  buttonColor,
  buttonHoverColor,
}: EditableListProps<T>) {
  if (!items || items.length === 0) {
    return <p className="text-gray-500 text-sm">{emptyMessage}</p>;
  }

  return (
    <ul className="text-gray-700 text-sm space-y-2">
      {items.map((item, i) => (
        <li
          key={i}
          className={`${bgColor} border ${borderColor} rounded px-3 py-2 flex items-center justify-between`}
        >
          {renderItem(item, i)}
          <button
            type="button"
            className={`${buttonColor} hover:${buttonHoverColor} text-sm`}
            onClick={() => {
              onEdit(i);
              onReturnToForm();
            }}
          >
            ✏️
          </button>
        </li>
      ))}
    </ul>
  );
}
